import React from 'react';
import { string, bool, oneOf } from 'prop-types';
import classNames from 'classnames';
import { getContext } from '@fiverr-private/fiverr_context';
import { Icon } from '@fiverr-private/fit';
import { EnvelopeIcon, BellIcon } from '@fiverr-private/icons';
import NotificationsDrawer from '@fiverr-private/realtime_notifications/src/NotificationsDrawer';
import { APP_NAME_NOTIFICATIONS } from '@fiverr-private/realtime_notifications/src/NotificationsDrawer/enums/apps';
import { localeSettings, rollouts, notificationSoundEnabled } from '../../PropTypes';
import { sendBigQueryEvent } from '../../utils/bigQuery';

import styles from './style.module.scss';

import './style.scss';

const DRAWER_TYPES = {
    NOTIFICATIONS: 'notifications',
    MESSAGES: 'messages',
};

const bigQueryBuyer = (type) => {
    const { pageCtxId, userId } = getContext();

    return {
        entity: 'client',
        action: {
            type: 'click',
        },
        group: 'header_clicks',
        type: `clicked_header.${type}`,
        page: {
            ctx_id: pageCtxId,
            element: {
                type: 'button',
            },
        },
        ...(userId && {
            user: {
                id: userId,
            },
        }),
    };
};

const handleTriggerClick = ({ isOpen, appName } = {}, onClick) => {
    if (onClick) {
        onClick({ isOpen, appName });
    }

    if (!isOpen) {
        return;
    }

    const type = appName === APP_NAME_NOTIFICATIONS ? appName : 'inbox';
    const data = bigQueryBuyer(type);

    sendBigQueryEvent(data);
};

const Messages = ({ username, drawerType, showAsIcons, iconColor }, { locale, notificationSoundEnabled }) => {
    const decidedDrawerType = showAsIcons && !drawerType ? DRAWER_TYPES.MESSAGES : drawerType;
    const isNotifications = decidedDrawerType === DRAWER_TYPES.NOTIFICATIONS;
    const wrapperClassName = classNames({ 'messages-wrapper': showAsIcons });
    const props = {
        username,
        locale,
        notificationSoundEnabled,
        drawerType: decidedDrawerType,
        popoverClassName: classNames({
            'popover-notifications-drawer-light': showAsIcons,
            'popover-letter-drawer': showAsIcons && !isNotifications,
            'popover-bell-drawer': showAsIcons && isNotifications,
        }),
        popoverBoxClassName: !drawerType || showAsIcons ? styles.popoverBox : '',
        onTriggerClick: handleTriggerClick,
        unreadDotClassName: classNames({
            'notifications-drawer-letter-unread': showAsIcons && !isNotifications,
            'notifications-drawer-bell-unread': showAsIcons && isNotifications,
        }),
    };

    if (showAsIcons) {
        props.trigger = (
            <Icon size={20} color={iconColor}>
                {isNotifications ? <BellIcon /> : <EnvelopeIcon />}
            </Icon>
        );
    }

    return (
        <div className={wrapperClassName}>
            <NotificationsDrawer {...props} />
        </div>
    );
};

Messages.propTypes = {
    username: string.isRequired,
    drawerType: oneOf(Object.values(DRAWER_TYPES)),
    iconColor: string,
    isBusinessPro: bool,
    showAsIcons: bool,
};

Messages.contextTypes = {
    locale: localeSettings.locale,
    rollouts,
    notificationSoundEnabled,
};

Messages.DRAWER_TYPES = DRAWER_TYPES;

export default Messages;
